import { Layout } from "providers/Layout";
import { settingsCards } from "./constants";
import { useNavigate } from "react-router-dom";
import { useAuthContext } from "providers/Auth";
import { useMemo } from "react";

export const SettingsView = () => {
  const navigate = useNavigate();
  const { type } = useAuthContext();

  const cards = useMemo(() => {
    if (type.isPropertyManager)
      return settingsCards.filter((card) =>
        ["profile", "notifications"].includes(card.id)
      );

    if (type.isBoomScreen)
      return settingsCards.filter((card) => !["team"].includes(card.id));

    // SDK, Manual, PMS (Boomreport)
    return settingsCards.filter(
      (card) => !["user", "notifications"].includes(card.id)
    );
  }, [settingsCards, type]);

  return (
    <Layout>
      <h1 className="mb-6 text-2xl font-bold text-content-1000">Settings</h1>
      <div className="grid w-fit gap-4 md:grid-cols-3">
        {cards.map((card) => {
          return (
            <div
              className="animate-appear flex w-full cursor-pointer flex-col rounded-lg border border-alpha-100 bg-background-1000 shadow-sm hover:border-alpha-200 hover:shadow-lg lg:max-w-[312px]"
              key={card.id}
              onClick={() => navigate(card.link)}
            >
              <div className="p-6">
                <card.icon size="24" />
                <h2 className="mb-2 mt-7 text-base font-bold text-content-1000">
                  {card.title}
                </h2>
                <p className="text-sm font-medium text-content-300 ">
                  {card.description}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </Layout>
  );
};
